import { TokenStorageService } from "./token-storage.service";

/**
 * Chiavi di `localStorage` che appartengono a UNA sessione, e che quindi non devono sopravviverle.
 *
 * `loginCompletedWithMfa` non viene più scritta da nessuno (lo stato dell'MFA arriva dal server,
 * `GET /authn/mfaStatus`): resta in elenco per ripulire i browser che ce l'hanno ancora.
 */
const SESSION_LOCAL_STORAGE_KEYS = [
  "selectedAreaId",
  "areaSelectionShown",
  "locale",
  "originalRequestedUrl",
  "loginCompletedWithMfa"
];

/** Chiavi di `sessionStorage` legate alla sessione. */
const SESSION_SESSION_STORAGE_KEYS = [
  "SSO_LOGIN",
  "originalRequestedUrl"
];

/**
 * Ripulisce tutto lo stato locale di una sessione: il token e le chiavi che lo accompagnano.
 *
 * Esiste perché la stessa pulizia era scritta in tre posti diversi e in tre modi diversi — il
 * logout, il cambio tenant e la gestione di un errore di autenticazione — e nessuno dei tre
 * ripuliva le stesse chiavi. L'esito era che dopo un logout restavano in `localStorage`
 * l'indicazione di aver completato il login con l'MFA e l'ultima URL richiesta, che il login
 * successivo (magari di un altro utente, sullo stesso browser) si ritrovava addosso.
 *
 * Le chiavi non esistenti vengono ignorate: `removeItem` non lancia.
 * @param tokenStorage Servizio che sa dove vive il token (cookie o sessionStorage)
 * @param tokenKey Chiave del token per il tipo di login corrente; se assente si ripulisce il resto
 */
export function clearClientSession(tokenStorage: TokenStorageService, tokenKey: string | null | undefined): void {
  if (tokenKey) {
    tokenStorage.deleteToken(tokenKey);
  }
  for (const key of SESSION_LOCAL_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }
  for (const key of SESSION_SESSION_STORAGE_KEYS) {
    sessionStorage.removeItem(key);
  }
}
